import axios from "axios";
import { useQuickAuthStore } from "../../store/useQuickAuthStore";

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
    timeout: 100000,
});

axiosInstance.interceptors.request.use(
    config => {
        const token = useQuickAuthStore.getState().accessToken;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            const logout = useQuickAuthStore.getState().logout;
            logout();
            localStorage.removeItem("auth-storage");
            window.location.pathname = "/login";
        }

        return Promise.reject(error);
    },
);

export default axiosInstance;
